import PreFooter from '@/prefooter';
import {useTranslations} from 'next-intl';

const PrefooterSection = () => {
  const t = useTranslations('workableAi.prefooter');

  return <PreFooter title={t('title')} subtitle={t('subtitle')} />;
};

export default PrefooterSection;
